import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import { metaDefault } from "../../config/meta";
import FreeGames from "./FreeGames";
import HomeNav from "./homeNav";
import HomeLists from "./homeLists";
import { routeCodes } from "../../config/routes";
import { isLoggedInSelector, modalToggle, roleSelector } from "../../redux/slices/loginSlice";
import { getString } from "../../utilities";
import { publicPath } from "../../config/routeCodes";
import { useLogout } from "../../hooks";
import { getLangCode, getParamValue } from "../../config";
import { language, userRoles } from "../../config/constants";
import Welcome from "./Welcome";

export default function Home({ shouldLogin }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isLoggedIn = useSelector(isLoggedInSelector);
  const dispatch = useDispatch();
  const role = useSelector(roleSelector);
  const { logout } = useLogout();

  const handleLogin = () => {
    const accessName = getParamValue("name", { location });
    const accessCode = getParamValue("code", { location });
    let redirectPath = getParamValue("path", { location });

    redirectPath = redirectPath ? `${publicPath}${redirectPath}` : routeCodes.HOME;

    if (!isLoggedIn) {
      dispatch(modalToggle({ path: redirectPath }));
    } else if (accessName || accessCode) {
      if (role !== userRoles.student) {
        logout();
      } else {
        // remove query parameters in the path for avoiding that URL has access name/code when logout
        const cleanPath = redirectPath.split("?")[0];
        navigate(cleanPath, { replace: true });
      }
    } else {
      navigate(redirectPath, { replace: true });
    }
  };

  useEffect(() => {
    if (shouldLogin) {
      handleLogin();
    }
  }, []);

  // If on the login page of the Spanish Site, we don't use the default title. Instead, use a specific one.
  const metaTitle =
    getLangCode() === language.la && location.pathname === routeCodes.LOGIN ? getString("login.metaTitle") : "";

  return (
    <>
      {metaDefault({ path: location.pathname, noCrawl: shouldLogin && !!location.search, title: metaTitle })}

      <div className="home">
        <Welcome />

        <FreeGames />

        <HomeNav />

        <HomeLists />
      </div>
    </>
  );
}
